import { arrayOf, bool, func, object, string } from 'prop-types';
import React from 'react';
import CheckCircle from 'material-ui/svg-icons/action/check-circle';
import Edit from 'material-ui/svg-icons/editor/mode-edit';
import Schedule from 'material-ui/svg-icons/action/schedule';

import { colors } from 'styles/provider';

const iconStyle = notStarted => ({
  color: `${notStarted ? colors.clrGray : colors.clrSecondary}`,
  width: '1.7rem',
  height: 'auto',
  margin: '0 0.8rem 0 0',
});

const boxStyles = notStarted => ({
  display: 'flex',
  minWidth: '21rem',
  height: '3rem',
  border: `0.1rem solid ${notStarted ? colors.clrGray : colors.clrSecondary}`,
  alignItems: 'center',

  color: `${notStarted ? colors.clrGray : colors.clrSecondary}`,
  fontWeight: 600,
  fontSize: '1.4rem',
  lineHeight: '1rem',

  margin: '1rem 0',
  padding: '0 1rem',
  cursor: `${notStarted ? 'default' : 'pointer'}`,
});

const DoneItem = ({ locale, notStarted, canUpdate, updateAction, viewAction }, { fm }) => (
  <div
    style={boxStyles(notStarted)}
    onClick={canUpdate && updateAction ? () => updateAction() : notStarted ? null : () => viewAction()}
  >
    {notStarted ? (
      <Schedule style={iconStyle(notStarted)} />
    ) : canUpdate ? (
      <Edit style={iconStyle(notStarted)} />
    ) : (
      <CheckCircle style={iconStyle(notStarted)} />
    )}
    {fm(locale)}
  </div>
);
DoneItem.contextTypes = {
  fm: func,
};
DoneItem.propTypes = {
  locale: string,
  notStarted: bool,
  canUpdate: bool,
  updateAction: func,
  viewAction: func,
};

class DoneItemsList extends React.Component {
  render() {
    const { itemList } = this.props;
    return (
      <div style={{ display: 'flex', alignItems: 'flex-start' }}>
        <div>
          {itemList.map(f => {
            return (
              <DoneItem
                key={f.locale}
                locale={f.locale}
                notStarted={f.notStarted}
                canUpdate={f.canUpdate}
                updateAction={() => f.updateAction()}
                viewAction={() => f.viewAction()}
              />
            );
          })}
        </div>
      </div>
    );
  }
}

DoneItemsList.propTypes = {
  itemList: arrayOf(object), // { locale: string, notStarted?: boolean, canUpdate?: boolean, updateAction?: func }
};

export default DoneItemsList;
